var _style, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgTruckConfigurator2448Px = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Lager_13",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 256 256",
    style: {
      enableBackground: "new 0 0 256 256"
    },
    xmlSpace: "preserve",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\r\n\tpath.outer-ring {\r\n\t\tfill: currentcolor;\r\n\t\tstroke: currentcolor;\r\n\t}\r\n\r\n\t.tiny-sliders {\r\n\t\tfill: none;\r\n\t\tstroke-linecap: round;\r\n\t\tstroke-linejoin: round;\r\n\t\tstroke-miterlimit: 10;\r\n\t\tstroke-width: 9;\r\n\t\tstroke: currentcolor;\r\n\t}\r\n")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "outer-ring",
    d: "M128,36.1c-50.7,0-91.9,41.2-91.9,91.9s41.2,91.9,91.9,91.9s91.9-41.2,91.9-91.9S178.7,36.1,128,36.1z  M128,209.9c-45.2,0-81.9-36.8-81.9-81.9S82.8,46.1,128,46.1s81.9,36.8,81.9,81.9S173.2,209.9,128,209.9z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    className: "tiny-sliders",
    x1: 118.6,
    y1: 90.7,
    x2: 180.5,
    y2: 90.7
  }), /*#__PURE__*/React.createElement("line", {
    className: "tiny-sliders",
    x1: 76,
    y1: 90.3,
    x2: 90.3,
    y2: 90.3
  }), /*#__PURE__*/React.createElement("line", {
    className: "tiny-sliders",
    x1: 161.9,
    y1: 128.3,
    x2: 178.5,
    y2: 128.3
  }), /*#__PURE__*/React.createElement("line", {
    className: "tiny-sliders",
    x1: 76,
    y1: 128.3,
    x2: 128.3,
    y2: 128.3
  }), /*#__PURE__*/React.createElement("line", {
    className: "tiny-sliders",
    x1: 118.8,
    y1: 166.3,
    x2: 180.5,
    y2: 166.3
  }), /*#__PURE__*/React.createElement("line", {
    className: "tiny-sliders",
    x1: 76,
    y1: 166.3,
    x2: 90.3,
    y2: 166.3
  }), /*#__PURE__*/React.createElement("circle", {
    className: "tiny-sliders",
    cx: 104.5,
    cy: 90.3,
    r: 14.3
  }), /*#__PURE__*/React.createElement("circle", {
    className: "tiny-sliders",
    cx: 142.5,
    cy: 128.3,
    r: 14.3
  }), /*#__PURE__*/React.createElement("circle", {
    className: "tiny-sliders",
    cx: 104.5,
    cy: 166.3,
    r: 14.3
  })))));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgTruckConfigurator2448Px);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/truck-configurator-24-48px.464c572e1e5742d7ddffbe1eba27f6eb.svg";